import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import showAlert from "utils/showAlert";
import TermsAndConditions from "terms_and_conditions/TermsAndConditions";

export default function TermsAndConditionsModal(props) {
  console.log(props);

  const acceptTerms = () => {
    props.hideTermsModal()
  } 

  return (
    <>
      <Modal show={props.show} onHide={props.hideTermsModal} className="terms-and-conditions-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>Terms & Conditions</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <p className="mb-2"><b>Please accept the DataPulse Terms and Conditions to use the software.</b></p>
            <div className="datapulse-terms-and-conditions">
              <TermsAndConditions />
            </div>
          </div>

          <div className="terms-and-conditions-footer">
            <button type="button" className="button b-size-normal skip-button" onClick={props.hideTermsModal}>
              Cancel
            </button>
            <div className="accept-box">
              <div className="lite-checkbox-container">
                <label htmlFor="accept-terms-checkbox">I accept the Terms and Conditions</label>
                <input type="checkbox" id="accept-terms-checkbox" name="accept-terms-checkbox" className="lite-checkbox" onChange={() => props.setAcceptedTerms(!props.acceptedTerms)} checked={props.acceptedTerms} />
              </div>
              <button type="button" className={`button b-type-primary b-size-normal b-color-green ${!props.acceptedTerms && "disabled"}`} onClick={acceptTerms} disabled={!props.acceptedTerms}>
                Next
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
